import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { DeleteStatusResult } from './delete-status.result';

@Injectable()
export class DeleteStatusUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);

  execute(id: string): Observable<DeleteStatusResult> {
    this.state.setDeletingStatus(true);

    // A delete failure is intentionally left to propagate to the caller instead of being written to
    // state.setError: that signal drives the statuses *list*, so recording a delete error there
    // blanked the whole table with "Failed to load statuses". The caller reports it as a toast.
    return this.repository.deleteStatus(id).pipe(
      map(() => ({ success: true })),
      finalize(() => {
        this.state.setDeletingStatus(false);
      }),
    );
  }
}
